import { useState } from "react";
import styled from "styled-components";

import NavItem from "./NavItem";
import {
  SectionTabBar,
  SectionTabButton,
  SectionTabBarWrapper,
} from "./SectionTabBar";

export default function Tools() {
  const [selectedItem, setSelectedItem] = useState(false);
  return (
    <Wrapper>
      <SectionTabBarWrapper style={{ marginLeft: 32, marginRight: 32 }}>
        <SectionTabBar buttonsPerRow={2}>
          <SectionTabButton
            icon="fa-duotone fa-solid fa-table"
            title="Report Builder"
            itemKey="famreg"
            setSelectedItem={setSelectedItem}
            selectedItem={selectedItem}
          />
          <SectionTabButton
            icon="fa-duotone fa-solid fa-hands-praying"
            title="Prayer Requests"
            itemKey="famreg"
            setSelectedItem={setSelectedItem}
            selectedItem={selectedItem}
          />
        </SectionTabBar>
      </SectionTabBarWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-bottom: 12px;
  position: relative;
`;
